import { api } from "../../utils/api";

export async function postSicrediPaidQuery(payload = {}) {
    try {
        const response = await api.post(`/homologation/sicredi_paid_query`, payload);
        return response.data;
    } catch (error) {
        console.error("Erro ao consultar parcelas pagas do Sicredi:", error);
        throw error;
    }
}
